import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loader, Pagination } from '@components/common';
import { isEqual } from 'lodash';
import { push as pushAction } from 'react-router-redux';
import { Table } from '@components';
import Actions, { thunks } from '@redux/locations';
import ReportActions from '@redux/reports';
import { officersColumns } from '../utils/columnsDefinition';

class OfficersList extends Component {
	constructor() {
		super();
		this.columns = officersColumns(this.onClickReport);
	}

	shouldComponentUpdate = ({
		loading, data, totalCount, filters,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.loading, loading)
			|| !isEqual(lastProps.data, data)
			|| !isEqual(lastProps.totalCount, totalCount)
			|| !isEqual(lastProps.filters, filters)
		);
	};

	componentWillUnmount = () => {
		const { updateFilters } = this.props;
		updateFilters('officers', { pageNumber : 1 });
	}

	onPaginate = (pageNumber) => {
		const {
			getOfficers,
			updateFilters,
		} = this.props;

		updateFilters('officers', { pageNumber });

		getOfficers();
	}

	onClickReport = (officerId) => () => {
		const { receiveData, push } = this.props;

		receiveData([
			{ property : 'filterForm.reportType', value : 4 },
			{ property : 'filterForm.officer', value : officerId },
		]);

		push('/reports');
	}

	render() {
		const {
			data,
			loading,
			totalCount,
			filters : {
				pageNumber,
				displayCount,
			},
		} = this.props;

		return (
			<Fragment>
				<Table
					className="compact-row header-dark"
					rowKey="Id"
					columns={this.columns}
					data={data}
				/>
				<Pagination
					minimal
					className="padding-15"
					totalCount={totalCount}
					displayCount={displayCount}
					pageNumber={pageNumber}
					onPaginate={this.onPaginate}
				/>
				<Loader active={loading} />
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	locations : {
		details : {
			officers : {
				data,
				totalCount,
				filters,
			},
		},
		loading : { officers : loading },
	},
}) => ({
	data,
	loading,
	totalCount,
	filters,
});

const mapDispatchToProps = (dispatch) => ({
	push          : bindActionCreators(pushAction, dispatch),
	getOfficers   : bindActionCreators(thunks, dispatch).getOfficers,
	updateFilters : bindActionCreators(Actions, dispatch).updateSectionFilters,
	receiveData   : bindActionCreators(ReportActions, dispatch).receiveData,
});

OfficersList.propTypes = {
	data          : PropTypes.array,
	getOfficers   : PropTypes.func.isRequired,
	loading       : PropTypes.bool,
	push          : PropTypes.func.isRequired,
	receiveData   : PropTypes.func.isRequired,
	totalCount    : PropTypes.number,
	updateFilters : PropTypes.func.isRequired,
	filters       : PropTypes.object,
};

OfficersList.defaultProps = {
	data       : [],
	loading    : false,
	totalCount : 0,
	filters    : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(OfficersList);
